import { themeByService } from '@repo/styles';
import cn from 'classnames';
import { CSSProperties } from 'styled-components';

import { IConDefaultType } from 'Icons';

import { IThrillIconProps, ThrillIconVariant } from '.';

function TingleThrillIcon({
  color = themeByService().color.static.adult.light,
  className,
  size = 24,
  rotate,
  flip,
  variant = ThrillIconVariant.DEFAULT,
  style,
}: IThrillIconProps) {
  const defaultStyle: CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 100,
    border: `1.2px solid ${color}`,
    background: '#FFF',
  };

  const mergedStyle = {
    width: size,
    height: size,
    transform: `rotate(${rotate}deg)`,
    ...(variant === ThrillIconVariant.DEFAULT ? defaultStyle : {}),
    ...style,
  };
  return (
    <i className={cn('dds-icon', className, { flip })} style={mergedStyle}>
      {variant === ThrillIconVariant.DEFAULT && (
        <svg
          viewBox="0 0 24 24"
          style={{ width: '100%', height: 'auto' }}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" fill="white" /> */}
          <path
            d="M12.1714 19H11.8286C11.0572 14.782 9.943 12.9872 6 12.1794V11.8206C10.0285 11.0128 11.1427 9.12807 11.8286 5H12.1714C12.9428 9.21798 14.057 11.0128 18 11.8206V12.1794C13.9715 12.9872 12.8573 14.8719 12.1714 19Z"
            fill={color}
          />
        </svg>
      )}
      {variant === ThrillIconVariant.ONLY_ICON && (
        <svg
          viewBox="0 0 14 14"
          style={{ width: '100%', height: 'auto' }}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.17139 14H6.82861C6.05719 9.78202 4.943 7.98715 1 7.17945V6.82055C5.02851 6.01284 6.1427 4.12807 6.82861 0H7.17139C7.94281 4.21798 9.057 6.01284 13 6.82055V7.17945C8.97149 7.98715 7.8573 9.87193 7.17139 14Z"
            fill={color || '#fff'}
          />
        </svg>
      )}
      {variant === ThrillIconVariant.SIDE_MENU && (
        <svg viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" width="13" height="13" rx="6.5" fill={color} />
          <path
            d="M7.11008 11.057H6.89008C6.39497 8.34981 5.67986 7.19784 3.14917 6.67944V6.44909C5.73474 5.93069 6.44985 4.721 6.89008 2.07153H7.11008C7.6052 4.77871 8.3203 5.93069 10.851 6.44909V6.67944C8.26542 7.19784 7.55031 8.40752 7.11008 11.057Z"
            fill="white"
          />
        </svg>
      )}
    </i>
  );
}

export default TingleThrillIcon;
